// @auto-index

import _1r1920x1200 from './1r1920x1200.jpg'
import _2r1920x1200 from './2r1920x1200.jpg'
import _3r1920x1200 from './3r1920x1200.jpg'
import _4r1920x1200 from './4r1920x1200.jpg'
import _5r1920x1200 from './5r1920x1200.jpg'
import _6r1920x1200 from './6r1920x1200.jpg'
import _7r1920x1200 from './7r1920x1200.jpg'

export { default as _1r1920x1200 } from './1r1920x1200.jpg'
export { default as _2r1920x1200 } from './2r1920x1200.jpg'
export { default as _3r1920x1200 } from './3r1920x1200.jpg'
export { default as _4r1920x1200 } from './4r1920x1200.jpg'
export { default as _5r1920x1200 } from './5r1920x1200.jpg'
export { default as _6r1920x1200 } from './6r1920x1200.jpg'
export { default as _7r1920x1200 } from './7r1920x1200.jpg'

export default {
  _1r1920x1200,
  _2r1920x1200,
  _3r1920x1200,
  _4r1920x1200,
  _5r1920x1200,
  _6r1920x1200,
  _7r1920x1200
}
